export default __webpack_public_path__ + "static/media/fanfary.a5306412.mp3";